export const CaseContactRole = {
    OWNER: "OWNER",
    ADMINISTRATIVE_ADDRESS: "ADMINISTRATIVE_ADDRESS",
    BUILDING_LEASEHOLDER: "BUILDING_LEASEHOLDER",
    ENTITLEMENT_TO_EASEMENT: "ENTITLEMENT_TO_EASEMENT",
    ADDRESS_CONTACT: "ADDRESS_CONTACT",
    HAS_OBJECTION: "HAS_OBJECTION",
    LEGAL_REPRESENTATION: "LEGAL_REPRESENTATION",
    TENANT: "TENANT"
} as const;
export type CaseContactRole = (typeof CaseContactRole)[keyof typeof CaseContactRole];
export const LegacyCaseStatus = {
    PREPARE_OBJECTION: "PREPARE_OBJECTION",
    SEARCH_APPOINTMENT: "SEARCH_APPOINTMENT",
    NEGOTIATION_SCHEDULED: "NEGOTIATION_SCHEDULED",
    ADJUSTMENT_OBJECTION: "ADJUSTMENT_OBJECTION",
    OBJECTION_WITHDRAWN: "OBJECTION_WITHDRAWN",
    PARTIAL_WITHDRAWAL: "PARTIAL_WITHDRAWAL",
    NO_AGREEMENT: "NO_AGREEMENT"
} as const;
export type LegacyCaseStatus = (typeof LegacyCaseStatus)[keyof typeof LegacyCaseStatus];
export const CasePersonalDataSalutation = {
    MR: "MR",
    MRS: "MRS",
    NO_SALUTATION: "NO_SALUTATION"
} as const;
export type CasePersonalDataSalutation = (typeof CasePersonalDataSalutation)[keyof typeof CasePersonalDataSalutation];
export const CollectionPermission = {
    VIEW_ALL: "VIEW_ALL",
    EDIT_ALL: "EDIT_ALL",
    ADMIN: "ADMIN"
} as const;
export type CollectionPermission = (typeof CollectionPermission)[keyof typeof CollectionPermission];
export const CollectionChapterPermission = {
    NONE: "NONE",
    READ: "READ",
    WRITE: "WRITE"
} as const;
export type CollectionChapterPermission = (typeof CollectionChapterPermission)[keyof typeof CollectionChapterPermission];
export const IncidentPermission = {
    SUBMIT: "SUBMIT",
    EDIT: "EDIT"
} as const;
export type IncidentPermission = (typeof IncidentPermission)[keyof typeof IncidentPermission];
export const MiroResourceType = {
    BOARD: "BOARD",
    SPACE: "SPACE"
} as const;
export type MiroResourceType = (typeof MiroResourceType)[keyof typeof MiroResourceType];
export const MiroSharingAccessLevel = {
    PRIVATE: "PRIVATE",
    VIEW: "VIEW",
    COMMENT: "COMMENT",
    EDIT: "EDIT"
} as const;
export type MiroSharingAccessLevel = (typeof MiroSharingAccessLevel)[keyof typeof MiroSharingAccessLevel];
export const ProjectMiroBoardRelation = {
    DIRECT: "DIRECT",
    SPACE: "SPACE"
} as const;
export type ProjectMiroBoardRelation = (typeof ProjectMiroBoardRelation)[keyof typeof ProjectMiroBoardRelation];
export const OfferStateType = {
    DRAFT: "DRAFT",
    PROGRESS: "PROGRESS",
    SUBMITTED: "SUBMITTED",
    NOT_SUBMITTED: "NOT_SUBMITTED",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED"
} as const;
export type OfferStateType = (typeof OfferStateType)[keyof typeof OfferStateType];
export const OfferDocumentState = {
    DONE: "DONE",
    DRAFT: "DRAFT"
} as const;
export type OfferDocumentState = (typeof OfferDocumentState)[keyof typeof OfferDocumentState];
export const FolderDomain = {
    INTERNAL: "INTERNAL",
    EXTERNAl: "EXTERNAl"
} as const;
export type FolderDomain = (typeof FolderDomain)[keyof typeof FolderDomain];
export const RoadmapKindOfWork = {
    EcologicalContingency: "EcologicalContingency",
    SurfaceConstruction: "SurfaceConstruction",
    UndergroundConstruction: "UndergroundConstruction",
    Upvaluation: "Upvaluation"
} as const;
export type RoadmapKindOfWork = (typeof RoadmapKindOfWork)[keyof typeof RoadmapKindOfWork];
export const SiaPhase = {
    StrategicPlanning: "StrategicPlanning",
    PreliminaryStudies: "PreliminaryStudies",
    ProjectPlanning: "ProjectPlanning",
    InvitationToTender: "InvitationToTender",
    Realization: "Realization",
    Management: "Management"
} as const;
export type SiaPhase = (typeof SiaPhase)[keyof typeof SiaPhase];
export const RoadmapClearanceStatus = {
    Draft: "Draft",
    Pending: "Pending",
    Approved: "Approved"
} as const;
export type RoadmapClearanceStatus = (typeof RoadmapClearanceStatus)[keyof typeof RoadmapClearanceStatus];
export const Locale = {
    DE: "DE",
    EN: "EN",
    FR: "FR",
    IT: "IT"
} as const;
export type Locale = (typeof Locale)[keyof typeof Locale];
export const SharepointSiteRequestStatus = {
    Created: "Created",
    Pending: "Pending",
    Timeout: "Timeout",
    Failed: "Failed"
} as const;
export type SharepointSiteRequestStatus = (typeof SharepointSiteRequestStatus)[keyof typeof SharepointSiteRequestStatus];
